import { CpgReport } from '@features/campaigns';
import { highlightsText } from '@features/campaigns/subdomains/cpg';
import {
  addNewlinesToSentences,
  wrapBoldValue,
  wrapLciValue,
} from '@features/lci-report/utils/default-text';

export const getSummaryDefaultText = (
  report: Pick<
    CpgReport,
    | 'uniqueUsers'
    | 'totalProjectedSales'
    | 'incrementalSalesLift'
    | 'projectedIncrementalSales'
  >,
  campaignName: string
): string => {
  const textList = highlightsText({
    metrics: {
      uniqueUsers: report.uniqueUsers ?? 0,
      totalProjectedSales: report.totalProjectedSales,
      incrementalSalesLift: report.incrementalSalesLift,
      projectedIncrementalSales: report.projectedIncrementalSales,
    },
    campaignName,
    formatValues: {
      uniqueUsers: wrapBoldValue,
      totalProjectedSales: wrapBoldValue,
      incrementalSalesLift: wrapLciValue,
      projectedIncrementalSales: wrapLciValue,
    },
  });

  return addNewlinesToSentences(textList.join(''));
};
